import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import theme from 'src/theme';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './App';
// import ErrorBoundary from 'src/views/errors/error-boundary';





ReactDOM.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      {/* <ErrorBoundary> */}
      <App />
      {/* </ErrorBoundary> */}
    </BrowserRouter>
  </ThemeProvider>
  ,
  document.getElementById('root')
);
